// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';

const COMPONENTS = {
  p: <p className="text-sm text-gray-500" />,
  i: <span className="italic" />,
  b: <span className="font-medium" />,
  u: <span className="underline" />,
  h1: <span className="title" />,
  h2: <span className="title" />,
  h3: <span className="title" />,
  label: <span className="text-base font-medium text-gray-900" />,
};

export function BrandedTrans({ values, ...props }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableValues = useMemo(() => ({ ...brand, values }), [JSON.stringify(values)]);
  return <Trans {...props} components={COMPONENTS} values={stableValues} />;
}
